import styled from 'styled-components';

const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: rgb(242, 242, 242);
`;

export default Divider;
